/* =====================================================================
   mk-portal-widgets.js  (Shopify theme asset)
  MK Supplements - customer portal widgets (Skio Customer Portal v3)
  ------------------------------------------------------------------
  Install: loaded by snippets/mk-portal.liquid (defer, after mk-portal-core.js) with
  assets/mk-portal-widgets.css (switch mk_portal_rewards). Was the inline snippet
  snippets/mk-portal-widgets.liquid until 2026-10-10; moved to cached theme assets.

  Gate: everything below is inert unless the loader's gate put class "mk-portal-on" on <html>
  (mk_portal_mode 'all', or 'preview' in an opted-in browser). Every CSS selector starts with
  html.mk-portal-on and the script returns at once without the class, so with the gate closed
  the page is exactly Skio's own. Behaviour with the gate open is unchanged from the tested
  2026-10-09 version.

  r6 (2026-10-13, VERSION 1.2.0, read-only as window.MKPortalWidgets.version): texts title "Get texts from
  MK Supplements"; the texts claim steps say a confirmation text may follow (the SMS list is double opt-in);
  the texts points from OPTIN_POINTS when Skio's card shows no number (data-mk-earn-pts-src); no
  "No expiry date" on codes; "Your codes" also when there are only past codes (CODES_PAST_ONLY).
  r6 review (2026-10-13): in the sign-up pop-up "MK Supplements" never breaks between its two words (BRAND in a
  nowrap span; the words are unchanged). Skio's texts card title keeps a normal space: its column is too narrow for
  the two words on one line next to "Claim points", and a no-break space split "Supplements" itself at 390 px.
  The texts "claimed" hint shows the reply word in bold, as the claim
  step does, with a gap above the cross-sell box (widgets.css).
  r7 (2026-10-14, VERSION 1.2.1, C10): the newsletter pop-up's email is filled in from the account whenever it is
  known, not only when it was known at the moment the pop-up opened. Live (r6, Jim 2026-10-13) the email field
  stayed empty while the texts pop-up had the number: r6 filled the form once at opening and once when the read that
  was running then finished; a read that ended without the customer (login token not there yet or expired for
  15 s, Skio's read failed, or a later read replacing it) left the form empty for the rest of the page view (the
  login token's email is the only other source and may be absent). Now every finished read fills the open form
  (email and number; never over anything the customer typed), an opening with nothing known starts a new read when
  the last one did not get the customer, a read that ends without the customer while the open form is still empty
  starts another (both: at most 3 per page view), and a route change forgets the previous email / number. The email
  shown passes the same check as Join newsletter (unchanged); none known: the field stays empty.
  Count-only facts for the live check: window.MKPortalWidgets.prefill() -> {read, email, phone} (where each value
  came from: 'skio' / 'token' / null; never the value).
  r7 review (2026-10-15, still 1.2.1: r7 is not released): the hint "We'll use the email on your account. You can
  change it." shows only while the field holds the account email (isAccountEmail, case aside): it hides as soon as
  the customer types another address (the form then sends that one) and shows again if they type the account email.
  r9 (2026-10-16, VERSION 1.3.0, C9 option c, Jim's OK 2026-10-15; needs core 1.4.0): "Claim points" in the sign-up
  pop-up claims in place, with no new tab and no reload, whenever the core can send it (MKPortal.canClaim(id): the
  loader's switch mk_portal_write_claim true, the reward one of the two ids of the claim guard, Klaviyo accepted that
  channel in this page view). The step keeps its title and texts lines; its gold Claim points is then a <button> (no
  new-tab icon, no "Opens in a new tab" line). The press mints the dialog's single-use confirmation ({kind: 'claim',
  rewardId}), shows "Adding your points..." with a spinner (announced in a polite live region) and calls
  MKPortal.claimReward() once. Sent (any answer): MKPortal.nudgeSkio() at 0, 1.5, 3.5, 6 and 10 s, so Skio refetches its
  own reward state; "N points added" still only once Skio's own card says Completed; no Completed CLAIM_WAIT_MS after
  the press: "Adding your points" with a secondary "Not showing up? Claim in a new tab" (r6's claim link, safe because
  Skio refuses a second claim). Nothing sent: another write running or an unconfirmed press keeps the button (a new
  press can try again); anything else (switch off, no login token, older core, ...) shows r6's claim step exactly, as
  does every case where the core cannot send (CLAIM_IN_PAGE = false forces it). The switch is false in the package.
  r9 review (2026-10-17, VERSION 1.3.1, needs core 1.4.1 for the core's own half): (1) a sign-up belongs to the customer
  logged in at its press (f.uid). Skio's logout / login need no page load, so the login is looked at again on every route
  change, on a storage event, every second while a sign-up waits for its claim, and before the pop-up opens on the claim
  step: another customer gets the card's Sign up and the form, never the claim step and never Skio's claim link; a
  login change while Klaviyo answers closes the pop-up without a claim step; the core's refusal not_signed_up forgets
  the sign-up (the form) instead of falling back to the claim link. (2) After a sent claim, reopening the pop-up shows
  "Adding your points..." only while the wait timer runs, else the waiting step with its link (the link's click no
  longer restarts the wait). (3) A slow tail of nudges (20, 35, 60 s) while Skio's card has not said Completed.

  What it does (only on /a/account pages, all built from data Skio already renders;
  every piece fails closed: if the data is missing, nothing is inserted):
    1. Rewards hero: replaces the contents of Skio's tier card with the customer's status:
       "You have N points", tier, next tier, expiry, member since, and a Ways to earn link.
       The redeem panel beside it owns the money: its big number becomes the dollar value of
       the points selected on the slider ("$5.00 off", "using 500 points"), live as the slider
       moves, and Skio's repeated "You have N Points. 100 points = $1 off..." line is hidden.
    2. Tiers card: one full-width card under the hero showing the five tiers as a ladder
       with what each one unlocks; the customer's position is marked. Skio's five
       separate tier cards, the hidden progress card and the footer are hidden.
    3. Tier names: strips the "Rewards Tier: " prefix from every text node and image alt
       inside the portal and keeps it stripped across Skio's re-renders.
    4. Ways to earn (r4, 2026-10-12): every card shows exactly ONE state on its right, read
       from Skio's own rendering of that action (never from the card's position):
         Skio's data per card, as Skio renders it (portal bundle, loyalty page):
           type     the action's icon: an uploaded icon is an <img alt="<type>">, else Skio's
                    stock icon for that type (EARN_ICONS); only when neither tells, Skio's
                    default description ("per $1 spent", "on your birthday each year" ...)
           done     Skio's "Completed" mark (check icon + text) in place of a link; Skio
                    renders it only when the action's completed flag is true
           link     Skio's own button (Redeem / Earn: Skio's copy setting) with its href
         The rules, in this order:
           a. points per $1 spent, anniversary  -> "Automatic" (muted). The per-dollar card is
              tagged data-mk-earn="credits-per-dollar-spent"; Skio's own "Completed" check
              there is replaced (it is not a finished one-time task).
           b. annual birthday gift -> "Automatic on your birthday" when Skio marks it done or
              the birthdate is on file (the "Add your birthdate" action marked done, or a date
              in Skio's Birthday line); otherwise "Add your birthdate" (Skio's own link for the
              card, else the birthdate card's link; no link: muted "Add your birthdate first").
              A recurring gift never reads "Completed".
           c. Skio marks it done (one-time actions) -> a "Completed" pill with a check (Skio's
              own word), the card muted, a small check on its icon.
           d. Skio shows a link -> Skio's own button, unchanged. Not on the newsletter / texts cards
              (batch 3): Skio's link there is its claim link, which credits the points with no sign-up;
              it is never shown (CSS guard keyed on the reward's type and redirect, plus the script).
           e. newsletter / texts (batch 3): our "Sign up" (opens the sign-up pop-up, 6 below) when the
              whole flow can run: Klaviyo's list for that channel is set up (MKPortal.klaviyo.ready),
              Skio's claim link on the card is valid (same origin, /a/account/credits/claim, a uuid id,
              an https redirect on mksupps.com) and the points are known; "Claim points" after
              Klaviyo accepted in this visit. Otherwise "Sign up" to NEWSLETTER_URL / SMS_URL (owner
              settings below); while they are null, a muted "Not done yet". Our titles and descriptions
              on these two cards ("Join our newsletter" / "Get texts from MK Supplements", "Earn N points
              when you ..."; N from Skio's card text, else (r6) the owner setting OPTIN_POINTS, used only
              when Skio's card shows no number at all; the source is on data-mk-earn-pts-src) and a phone
              icon on the texts card.
           f. anything else without a link -> a muted "Not done yet" (never blank).
         Nothing is ever marked completed unless Skio says so. Unknown type: c, d or f.
         Fail closed: when Skio's action slot shows something we do not recognise (no link, no
         known "Completed" mark, but visible text or an icon, e.g. a changed check icon or class),
         the card keeps Skio's own rendering untouched (state "skio") instead of a, b's "Add your
         birthdate", e or f; only the per-dollar and anniversary cards and a birthday gift with a
         birthdate on file still read "Automatic". Any error on a card: our state is removed and
         Skio's own action shows.
         A state label longer than 13 characters ("Automatic on your birthday", "Add your
         birthdate") tags the card data-mk-earn-long: on narrow cards the state then sits on its own
         row under the description, so the title keeps the full width.
    5. Redeemed code (r4): Skio's code field gets the code's length (--mk-code-chars) so the
       stylesheet can size it to one line beside Copy; then the real width is measured and the
       size stepped down (--mk-code-fit, to 12 px) until the code fits on one line; at 12 px the
       letter-spacing and side padding go (data-mk-code-tight). Only a code that does not fit even
       then is allowed to wrap (data-mk-code-wrap); nothing is cut off.
    6. Sign-up pop-up (batch 3, approved 2026-10-12): the shared dialog of the core (1.1.0). Email step
       (account email filled in, editable; r7: also when it arrives after the pop-up opened) or texts step
       (number filled in, consent box never ticked, the approved disclosure above "Sign up for texts"); checks first (nothing is sent on a bad
       email / number or an unticked box); then a single-use confirmation from the customer's own press
       and one Klaviyo request (core). Only after Klaviyo accepts, Skio's claim link for that reward (new
       tab; r9: a claim in place instead whenever the core can send it, see r9 above) and "Opens in a new tab. Come back to this tab to see your points." under: email (newsletter
       list RHNWWp, single opt-in) "You're in! Claim your N points"; texts (r6: SMS list VxmYUP is double
       opt-in, Jim 2026-10-12) "Thanks! Claim your N points" with "If you're new to our texts, look for a
       text from MK Supplements asking you to confirm. Reply Y to it ..." and "Already get our texts?
       There's nothing more to do." (Klaviyo's 202 proves neither a text nor a subscription, so nothing
       says one was sent; the reply word is SMS_CONFIRM_REPLY). "N points added" only once Skio's
       own card says completed (Skio refetches on focus; we read its card again on focus / return); 10 s
       after the customer is back without that: "Adding your points". Then (texts) "New to our texts?
       Reply Y to the confirmation text ..." and the other reward's cross-sell ("Want N more? Sign up for
       texts"). Typed values are never stored or logged.
    7. Your codes (batch 3): the customer's points codes (Skio CreditDiscounts, Skio's own loyalty
       document; past codes by a second read) under the points and redeem block: code, Copy, "$X off
       one order" (r6: no "No expiry date": the store's terms say codes expire 24 h after they are
       made; CODES_NO_EXPIRY); Past codes collapsed ("Used" / "Expired, points refunded"); r6: with
       no unused code but past ones, the card with "You have no unused codes right now." and Past codes
       only (CODES_PAST_ONLY); hidden with no codes at all or on any error; read again (fresh) after a
       redeem.
  Colours follow the portal stylesheet's --mk-* tokens when present, so the widgets match
  whichever portal theme is published. Plain CSS and JS (no Liquid), so both files can also
  be tested by injecting them into the Skio preview.
  Program constant: POINTS_PER_DOLLAR (100 points = $1) must match Skio > Loyalty > Credits.
  Owner settings (r4): NEWSLETTER_URL, SMS_URL = the pages where a customer signs up for the
  newsletter / texts (https://... or a /path on mksupps.com), or null (default: "Not done yet").
  Owner settings (r6, one line each, in sections 6 and 7): OPTIN_POINTS (texts 500 = Skio > Loyalty >
  Credits), SMS_CONFIRM_REPLY ('Y', the word Klaviyo's confirmation text asks for), CODES_NO_EXPIRY
  (false), CODES_PAST_ONLY (true).
   ===================================================================== */
(function () {
  function gateOn() {
    try { return document.documentElement.classList.contains('mk-portal-on'); } catch (e) { return false; }
  }
  if (window.__mkPortalWidgets || !gateOn()) return;
  window.__mkPortalWidgets = true;

  var POINTS_PER_DOLLAR = 100;           /* Skio > Loyalty > Credits: 1 USD = 100 points */
  /* Ways to earn (r4): where to sign up when Skio has no link for the action; null = "Not done yet" */
  var NEWSLETTER_URL = null;             /* e.g. 'https://mksupps.com/pages/newsletter' */
  var SMS_URL = null;                    /* e.g. 'https://mksupps.com/pages/texts' */
  var PREFIX = /Rewards Tier:\s*/gi;
  /* tier art: the loader's asset_url (window.MKPortalConfig.tierArt, this theme's own
     assets/mk-tier-*.webp, as the core and home use), falling back to the theme-57 URLs */
  var ART = {
    bone: 'https://mksupps.com/cdn/shop/t/57/assets/mk-tier-bone.webp',
    stone: 'https://mksupps.com/cdn/shop/t/57/assets/mk-tier-stone.webp',
    bronze: 'https://mksupps.com/cdn/shop/t/57/assets/mk-tier-bronze.webp',
    iron: 'https://mksupps.com/cdn/shop/t/57/assets/mk-tier-iron.webp',
    steel: 'https://mksupps.com/cdn/shop/t/57/assets/mk-tier-steel.webp'
  };
  try {
    var cfgArt = window.MKPortalConfig && window.MKPortalConfig.tierArt;
    Object.keys(ART).forEach(function (k) {
      var u = cfgArt && cfgArt[k];
      if (typeof u === 'string' && /^(https:)?\/\/[\w.-]+\/[\w\/.\-%?=&]+$/.test(u)) ART[k] = u;
    });
  } catch (e) { /* keep the fallback */ }

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function short(name) { return (name || '').replace(PREFIX, '').trim(); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function artFor(name, fallback) { return ART[short(name).toLowerCase()] || fallback || ''; }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function num(s) { var m = String(s || '').replace(/,/g, '').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; }
  function fmtNum(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function prettyDate(s) {
    /* "01/15/24" -> "Jan 15, 2024"; anything else is returned as is */
    var m = String(s || '').match(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/);
    if (!m) return s;
    var y = m[3].length === 2 ? 2000 + parseInt(m[3], 10) : parseInt(m[3], 10);
    var d = new Date(y, parseInt(m[1], 10) - 1, parseInt(m[2], 10));
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  /* ---- prefix stripping ---- */
  function stripPrefix(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      PREFIX.lastIndex = 0;
      if (v && PREFIX.test(v)) { PREFIX.lastIndex = 0; node.nodeValue = v.replace(PREFIX, ''); }
      PREFIX.lastIndex = 0;
    }
    qa('img[alt]', root).forEach(function (img) {
      PREFIX.lastIndex = 0;
      if (PREFIX.test(img.alt)) { PREFIX.lastIndex = 0; img.alt = img.alt.replace(PREFIX, ''); }
      PREFIX.lastIndex = 0;
    });
  }

  /* ---- data: tiers, progress, balance ---- */
  function readTiers() {
    var grid = q('[data-skio-name="tier-summary-benefits-grid"]');
    if (!grid) return null;
    var cards = qa(':scope > [data-skio-name="tier-benefit-card"]', grid);
    if (cards.length < 2) return null;
    var tiers = [], current = -1;
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      var icon = q('[data-skio-name="tier-benefit-card-icon"] img', c);
      var t = {
        name: short(text(q('[data-skio-name="tier-benefit-card-name"]', c))),
        req: text(q('[data-skio-name="tier-benefit-card-description"]', c)),
        perks: qa('[data-skio-name="tier-benefit-card-benefit-item"]', c).map(text).filter(Boolean),
        icon: icon ? (icon.currentSrc || icon.src) : '',
        current: c.classList.contains('border-brand-500')
      };
      if (!t.name) return null;
      if (t.current) current = i;
      tiers.push(t);
    }
    if (current < 0) return null;
    var pct = null, message = '';
    var pc = q('[data-skio-name="tier-progress-card"]');
    if (pc) {
      var bar = q('[role="progressbar"]', pc);
      if (bar) { var v = parseFloat(bar.getAttribute('aria-valuenow')); if (!isNaN(v)) pct = Math.max(0, Math.min(100, v)); }
      message = short(text(q('[data-skio-name="tier-progress-card-message-container"]', pc)));
    }
    var header = text(q('[data-skio-name="tier-summary-header"]'));
    return { tiers: tiers, current: current, pct: pct, message: message, header: header };
  }

  function readHero() {
    var card = q('[data-skio-name="tier-card"]');
    if (!card) return null;
    var balance = num(text(q('[data-skio-name="tier-card-balance-value"]', card)));
    if (balance == null) return null;
    var label = text(q('[data-skio-name="tier-card-balance-label"]', card)) || 'points';
    var expiry = text(q('[data-skio-name="tier-card-expiry-date"]', card));
    var tier = short(text(q('[data-skio-name="tier-card-tier-name"]', card)));
    var joined = text(q('[data-skio-name="tier-card-join-date"]', card)).replace(/^Joined\s*/i, '');
    var icon = q('[data-skio-name="tier-card-header"] img', card);
    var birthday = text(q('[data-skio-name="tier-summary-footer-birthday-container"] p'));
    return { balance: balance, label: label.toLowerCase(), expiry: expiry, tier: tier, joined: joined, icon: icon ? (icon.currentSrc || icon.src) : '', birthday: birthday };
  }

  /* ---- next tier wording (F-6, batch 2) ----
     Ours, from Skio's own data on the page: "Stone at 3 orders in a row" = the next tier's name (Skio's tier
     card) and its threshold, read from that card's requirement ("3 orders in a row", the tier's eligibility
     description). Only a requirement that is exactly a number of orders in a row is read; anything else (a
     spend or order-count tier, another wording) fails closed to Skio's own text: its progress message when it
     has one (Skio's copy settings stay as they are), else the requirement as Skio writes it. */
  function streakNeed(req) {
    var m = /^\s*(\d{1,3})\s+(?:subscription\s+)?orders?\s+in\s+a\s+row\s*\.?\s*$/i.exec(req || '');
    var n = m ? parseInt(m[1], 10) : NaN;
    return n > 0 ? n : null;
  }
  function nextAt(next) {
    var n = next ? streakNeed(next.req) : null;
    return n && next.name ? next.name + ' at ' + n + (n === 1 ? ' order in a row' : ' orders in a row') : null;
  }
  function nextLine(d, next, reach) {
    var ours = nextAt(next);
    if (ours) return ours;
    if (/\d/.test(d.message)) return reach ? d.message.replace(/\s*to unlock\s+/i, ' to reach ') : d.message;
    return next.name + (next.req ? ' at ' + next.req.toLowerCase() : '');
  }

  /* ---- 1. hero ---- */
  function buildHero(h, d) {
    var cur = d ? d.tiers[d.current] : null;
    var next = d && d.current < d.tiers.length - 1 ? d.tiers[d.current + 1] : null;
    var tierName = (cur && cur.name) || h.tier;
    var nextText = !d ? '' : !next ? 'Top tier reached' : nextLine(d, next, true);
    var expiry = /never/i.test(h.expiry) ? 'Never' : (h.expiry.replace(/^Expires?( on)?\s*/i, '') || '');
    var facts = '';
    if (tierName) facts += '<li><span class="mk-hero__k">Your tier</span><span class="mk-hero__v">' + (artFor(tierName, h.icon) ? '<img src="' + esc(artFor(tierName, h.icon)) + '" alt="">' : '') + esc(tierName) + '</span></li>';
    if (nextText) facts += '<li><span class="mk-hero__k">Next tier</span><span class="mk-hero__v">' + esc(nextText) + '</span></li>';
    if (expiry) facts += '<li><span class="mk-hero__k">Points expire</span><span class="mk-hero__v">' + esc(expiry) + '</span></li>';
    if (h.joined) facts += '<li><span class="mk-hero__k">Member since</span><span class="mk-hero__v">' + esc(prettyDate(h.joined)) + '</span></li>';
    return '<p class="mk-hero__eyebrow">Your points</p>' +
      '<h2 class="mk-hero__title">You have <strong>' + esc(fmtNum(h.balance)) + '</strong> ' + esc(h.label) + '</h2>' +
      (h.balance > 0 ? '' : '<p class="mk-hero__value">Every subscription order earns points.</p>') +
      (facts ? '<ul class="mk-hero__facts">' + facts + '</ul>' : '') +
      '<div class="mk-hero__actions">' +
        (q('[data-skio-name="credit-rewards"]') ? '<a class="mk-btn mk-btn--ghost" href="#mk-earn">Ways to earn</a>' : '') +
      '</div>';
  }

  /* ---- 1b. redeem panel: the selected points shown as money, once ---- */
  function syncRedeem() {
    var el = q('[data-skio-name="redeem-card-slider-value"]');
    if (!el) return;
    var pts = num(text(el));
    var label = (text(q('[data-skio-name="tier-card-balance-label"]')) || 'points').toLowerCase();
    if (pts == null || pts < 0) { el.removeAttribute('data-mk-usd'); el.removeAttribute('data-mk-pts'); return; }
    var usd = money(pts / POINTS_PER_DOLLAR) + ' off';
    var used = 'using ' + fmtNum(pts) + ' ' + (pts === 1 ? label.replace(/s$/, '') : label);
    if (el.getAttribute('data-mk-usd') !== usd) el.setAttribute('data-mk-usd', usd);
    if (el.getAttribute('data-mk-pts') !== used) el.setAttribute('data-mk-pts', used);
  }

  /* ---- 2. tiers card ---- */
  function buildTiers(d) {
    var n = d.tiers.length, cur = d.current, top = cur === n - 1;
    var frac = top ? 1 : (cur + (d.pct == null ? 0 : d.pct / 100)) / (n - 1);
    var next = top ? null : d.tiers[cur + 1];
    var ours = top ? null : nextAt(next);
    var title = top ? 'You are at the top tier'
      : (ours ? 'Next up: ' + ours : (/\d/.test(d.message) ? d.message : ('Next up: ' + nextLine(d, next, false))));
    var items = '';
    for (var i = 0; i < n; i++) {
      var t = d.tiers[i];
      var state = i < cur ? 'is-done' : i === cur ? 'is-current' : i === cur + 1 ? 'is-next' : 'is-locked';
      var pill = i === cur ? '<span class="mk-tp__pill">You are here</span>' : (i === cur + 1 && !top ? '<span class="mk-tp__pill">Next</span>' : '');
      var art = artFor(t.name, t.icon);
      var unlocks = t.perks.length ? '<ul class="mk-tp__unlocks">' + t.perks.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>' : '';
      items += '<li class="mk-tp__node ' + state + '">' +
        '<span class="mk-tp__art">' + (art ? '<img src="' + esc(art) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="mk-tp__body"><span class="mk-tp__name">' + esc(t.name) + '</span>' +
        (t.req ? '<span class="mk-tp__req">' + esc(t.req) + '</span>' : '') + pill + unlocks + '</span></li>';
    }
    return '<div class="mk-tp__head"><div><p class="mk-tp__eyebrow">' + esc(d.header || 'Tiers') + '</p><h3 class="mk-tp__title">' + esc(title) + '</h3></div>' +
      '<p class="mk-tp__sub">Tiers are based on subscription orders in a row. Each order placed on schedule moves you along the ladder, and each tier unlocks more.</p></div>' +
      '<ol class="mk-tp__ladder" style="--tp-n:' + n + ';--tp-fill-frac:' + frac.toFixed(3) + '">' + items + '</ol>' +
      '<p class="mk-tp__foot"><b>Streaks:</b> a skipped or missed order resets the count, and Iron and Steel members can ask support to restore one streak per year.</p>';
  }

  /* ---- 4. Ways to earn: one clear state per card (r4; rules in the header) ---- */
  var EARN_TYPES = { 'create-account': 1, 'credits-per-dollar-spent': 1, 'custom-action': 1, 'birthday': 1, 'date-of-birth': 1,
    'review': 1, 'anniversary': 1, 'newsletter-signup': 1, 'sms-opt-in': 1 };
  /* Skio's stock icon per action type: the start of its first path (portal bundle, loyalty page, icon map) */
  var EARN_ICONS = [
    ['M8.5 14.667A2.333', 'credits-per-dollar-spent'],   /* CurrencyDollarCircle */
    ['M12 6v16m0-16H8.464', 'birthday'],                 /* Gift01 */
    ['M21 10H3m13-8v4', 'date-of-birth'],                /* Calendar */
    ['M11.993 5.136', 'anniversary'],                    /* Heart */
    ['m2 7 8.165 5.715', 'newsletter-signup'],           /* Mail01 */
    ['M11 4H6.8', 'sms-opt-in'],                         /* Edit05 */
    ['M8.5 12.5S9.813', 'review'],                       /* MessageSmileSquare */
    ['M15.938 15.938A7', 'custom-action']                /* Coins01 (custom actions and create account) */
  ];
  var CHECK_PATH = 'm7.5 12 3 3 6-6';                    /* CheckCircle: Skio's "Completed" mark */
  /* Skio's default English descriptions (loyalty.reward.*): only when the icon does not tell */
  var EARN_TEXT = [
    [/\bper\s+(?:dollar|[^\s\d]{0,3}\s?1(?:[.,]00)?(?:\s?(?:usd|dollars?))?)\s+spent\b/i, 'credits-per-dollar-spent'],
    [/\bon your birthday each year\b/i, 'birthday'],
    [/\bfor entering your birthday\b/i, 'date-of-birth'],
    [/\bon your anniversary each year\b/i, 'anniversary'],
    [/\bsigning up for the newsletter\b/i, 'newsletter-signup'],
    [/\bsigning up for sms\b/i, 'sms-opt-in'],
    [/\bwrite a review\b/i, 'review']
  ];
  var SVGNS = 'http://www.w3.org/2000/svg';
  var EARN_SVG = {
    done: ['M20 6L9 17l-5-5'],
    auto: ['M21 12a9 9 0 1 1-3-6.7L21 8', 'M21 3v5h-5'],
    go: ['M5 12h14', 'M13 6l6 6-6 6'],
    /* batch 3: our icons (sign-up pop-up, texts card, Your codes) */
    mail: ['m2 7 8.165 5.715c.661.463.992.695 1.351.784a2 2 0 0 0 .968 0c.36-.09.69-.32 1.351-.784L22 7', 'M6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 20 5.12 20 6.8 20Z'],
    phone: ['M9 2h6a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z', 'M11 18h2'],
    star: ['M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9z'],
    check: ['M20 6 9 17l-5-5'],
    alert: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z', 'M12 7v6', 'M12 16.5v.5'],
    out: ['M7 17 17 7', 'M8 7h9v9'],
    copy: ['M11.5 9h7a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 9 18.5v-7A2.5 2.5 0 0 1 11.5 9Z', 'M5 15h-.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V5'],
    chev: ['m6 9 6 6 6-6']
  };
  function pathOf(svg) {
    var p = svg && svg.querySelector('path');
    return p ? String(p.getAttribute('d') || '').replace(/\s+/g, ' ').trim() : '';
  }
  function safeHref(u) {
    u = typeof u === 'string' ? u.trim() : '';
    if (/^\/(?!\/)[^\s"'<>\\]*$/.test(u)) return u;
    if (/^https:\/\/[\w.-]+(?::\d+)?(?:[\/?#][^\s"'<>\\]*)?$/i.test(u)) return u;
    return null;
  }
  function earnType(card) {
    var img = q('[data-skio-name="credit-reward-icon-custom"] img', card);
    var alt = img ? String(img.getAttribute('alt') || '').trim().toLowerCase() : '';
    if (EARN_TYPES[alt] === 1) return alt;   /* Skio renders an uploaded icon with alt = the action's type */
    /* batch 3: our own icon (the texts card's phone) is never read as Skio's */
    var d = pathOf(q('[data-skio-name="credit-reward-icon"] svg:not(.mk-earn-ico)', card)), i;
    if (d) for (i = 0; i < EARN_ICONS.length; i++) if (d.indexOf(EARN_ICONS[i][0]) === 0) return EARN_ICONS[i][1];
    var desc = text(q('[data-skio-name="credit-reward-description"]', card));
    for (i = 0; i < EARN_TEXT.length; i++) if (EARN_TEXT[i][0].test(desc)) return EARN_TEXT[i][1];
    /* batch 3: our own title / description on the two sign-up cards (set by earnCopy) */
    var mt = card.getAttribute('data-mk-earn-copy');
    return OPTIN[mt] ? mt : '';
  }
  function mine(n) { return !!(n && n.closest && n.closest('.mk-earn-state')); }
  /* Skio's own action: its link, or its "Completed" mark (rendered only for completed: true) */
  function earnSkio(card) {
    var act = q('[data-skio-name="credit-reward-action"]', card);
    if (!act) return null;
    var link = qa('a[href]', act).filter(function (a) { return !mine(a); })[0] || null;
    var mark = null, word = '';
    if (!link) {
      var kids = qa(':scope > :not(.mk-earn-state)', act);
      var check = kids.filter(function (k) { return k.tagName.toLowerCase() === 'svg' && pathOf(k).indexOf(CHECK_PATH) === 0; })[0];
      var span = kids.filter(function (k) { return k.tagName.toLowerCase() === 'span' && k.classList.contains('text-success'); })[0];
      if (check || span) { mark = check || span; word = span ? text(span) : ''; }
    }
    /* Skio shows something here that is neither its link nor its known "Completed" mark */
    var unknown = !link && !mark && qa(':scope > :not(.mk-earn-state)', act).some(function (k) {
      return !!text(k) || /^(svg|img)$/i.test(k.tagName) || !!q('svg, img', k);
    });
    return { act: act, link: link, done: !!mark, word: word, unknown: unknown };
  }
  function earnState(type, sk, ctx) {
    if (type === 'credits-per-dollar-spent' || type === 'anniversary') return { state: 'auto', label: 'Automatic' };
    if (type === 'birthday') {
      if (sk.done || ctx.birthday) return { state: 'auto', label: 'Automatic on your birthday' };
      if (sk.unknown) return { state: 'skio' };
      var h = safeHref(sk.link ? sk.link.getAttribute('href') : ctx.dobHref);
      return h ? { state: 'go', label: 'Add your birthdate', href: h } : { state: 'todo', label: 'Add your birthdate first' };
    }
    if (sk.done) return { state: 'done', label: sk.word || 'Completed' };
    /* batch 3: newsletter / texts. Skio's claim link there is never shown (it credits the points without a
       sign-up): our "Sign up" (the pop-up) when the whole flow can run (Klaviyo list set up, Skio's claim link
       valid, the points known), "Claim points" after Klaviyo accepted in this visit; else as before (e, f) */
    if (OPTIN[type]) {
      if (sk.unknown) return { state: 'skio' };
      if (ctx.offers && ctx.offers[type]) return { state: 'optin', label: optinFlow[type] && optinFlow[type].accepted ? 'Claim points' : 'Sign up' };
      if (sk.link && !isClaimHref(sk.link)) return { state: 'link' };   /* a claim link, valid or not, is never shown */
    } else {
      if (sk.link) return { state: 'link' };
      if (sk.unknown) return { state: 'skio' };
    }
    var u = type === 'newsletter-signup' ? safeHref(NEWSLETTER_URL) : type === 'sms-opt-in' ? safeHref(SMS_URL) : null;
    if (u) return { state: 'go', label: 'Sign up', href: u };
    return { state: 'todo', label: 'Not done yet' };
  }
  function earnIcon(name, cls) {
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2.2');
    svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    if (cls) svg.setAttribute('class', cls);
    (EARN_SVG[name] || []).forEach(function (d) { var p = document.createElementNS(SVGNS, 'path'); p.setAttribute('d', d); svg.appendChild(p); });
    return svg;
  }
  function earnNode(st, type) {
    var n = document.createElement(st.state === 'go' ? 'a' : st.state === 'optin' ? 'button' : 'span');
    n.className = 'mk-earn-state mk-earn-state--' + st.state + (st.state === 'optin' && st.label !== 'Sign up' ? ' mk-earn-state--claim' : '');
    if (st.state === 'go') n.setAttribute('href', st.href);
    if (st.state === 'optin') {
      n.setAttribute('type', 'button');
      n.setAttribute('data-mk-optin', type);
      n.addEventListener('click', function (ev) { optinOpen(type, ev); });
    }
    if (st.state === 'done' || st.state === 'auto') n.appendChild(earnIcon(st.state));
    var t = document.createElement('span');
    t.className = 'mk-earn-state__text';
    t.textContent = st.label;
    n.appendChild(t);
    if (st.state === 'go' || st.state === 'optin') n.appendChild(earnIcon('go'));
    return n;
  }
  function earnClear(card) {
    qa('.mk-earn-state', card).forEach(function (n) { n.remove(); });
    try { copyRestore(card); } catch (e) { /* ignore */ }
    card.removeAttribute('data-mk-earn');
    card.removeAttribute('data-mk-earn-state');
    card.removeAttribute('data-mk-earn-long');
  }
  function syncEarn() {
    /* r9 review: on every sync while a sign-up of this page view exists, is it still this customer's? (optinUserCheck) */
    try { if (Object.keys(optinFlow).some(function (t) { return signedUpFlows(optinFlow[t]); })) optinUserCheck(); } catch (e) { /* ignore */ }
    var cards = qa('[data-skio-name="credit-rewards-grid"] > [data-skio-name="credit-reward-card"]');
    if (!cards.length) return;
    var info = cards.map(function (c) {
      try { return { card: c, type: earnType(c), sk: earnSkio(c) }; } catch (e) { return { card: c, type: '', sk: null }; }
    });
    var ctx = { birthday: false, dobHref: null, offers: {} };
    info.forEach(function (x) {
      if (x.type !== 'date-of-birth' || !x.sk) return;
      if (x.sk.done) ctx.birthday = true;
      else if (x.sk.link && !ctx.dobHref) ctx.dobHref = x.sk.link.getAttribute('href');
    });
    if (/\d/.test(text(q('[data-skio-name="tier-summary-footer-birthday-container"] p')))) ctx.birthday = true;
    /* batch 3: the two sign-up cards (one card per type; a second card of the same type is left as Skio's) */
    var seen = {};
    info.forEach(function (x) {
      if (!OPTIN[x.type] || !x.sk) return;
      if (seen[x.type]) { x.dup = true; return; }
      seen[x.type] = true;
      try {
        hideClaim(x.sk);                       /* Skio's claim link: hidden by script too (the CSS guard is the first line) */
        x.pts = earnCopy(x.card, x.type);      /* our title / description; the points from Skio's own card */
        optinNote(x.type, x.card, x.sk, x.pts);
        var o = !x.sk.done && !x.sk.unknown ? optinOffer(x.type, x.sk, x.pts) : null;
        if (o) ctx.offers[x.type] = o;
      } catch (e) { x.sk = null; }
    });
    info.forEach(function (x) {
      var c = x.card;
      try {
        if (!x.sk) { earnClear(c); return; }
        var st = earnState(x.dup ? '' : x.type, x.sk, x.dup ? { birthday: ctx.birthday, dobHref: ctx.dobHref, offers: {} } : ctx);
        var sig = st.state + '|' + (st.label || '') + '|' + (st.href || '');
        var own = qa('.mk-earn-state', x.sk.act);
        var skio = st.state === 'link' || st.state === 'skio';   /* Skio's own rendering stays */
        var keep = skio ? !own.length
          : (own.length === 1 && own[0].getAttribute('data-sig') === sig && own[0] === x.sk.act.lastElementChild);
        if (!keep) {
          var hadFocus = own.some(function (n) { return n === document.activeElement || n.contains(document.activeElement); });
          own.forEach(function (n) { n.remove(); });
          if (!skio) {
            var n = earnNode(st, x.type); n.setAttribute('data-sig', sig); x.sk.act.appendChild(n);
            if (hadFocus && st.state === 'optin') { try { n.focus({ preventScroll: true }); } catch (e2) { /* ignore */ } }
          }
        }
        if (c.getAttribute('data-mk-earn') !== (x.type || 'unknown')) c.setAttribute('data-mk-earn', x.type || 'unknown');
        if (c.getAttribute('data-mk-earn-state') !== st.state) c.setAttribute('data-mk-earn-state', st.state);
        var long = !skio && (st.label || '').length > 13;
        if (long !== c.hasAttribute('data-mk-earn-long')) { if (long) c.setAttribute('data-mk-earn-long', ''); else c.removeAttribute('data-mk-earn-long'); }
      } catch (e) { try { earnClear(c); } catch (e2) { /* ignore */ } }
    });
    try { optinWatch(info); } catch (e) { /* ignore */ }
  }
  function clearEarn() { qa('[data-skio-name="credit-reward-card"]').forEach(function (c) { try { earnClear(c); } catch (e) { /* ignore */ } }); }

  /* ---- 6. Sign-up pop-up: newsletter and texts (batch 3, approved 2026-10-12) ----
     The card's "Sign up" opens the shared dialog (MKPortal.dialog, core 1.1.0). The customer's own press of the
     pop-up's button mints a single-use confirmation and only then is Klaviyo called (MKPortal.klaviyo: email and
     SMS are separate calls; SMS only with the consent box ticked). Only after Klaviyo accepts (2xx) does the
     pop-up show the claim step with Skio's own claim link for that reward (rebuilt from the validated id and
     redirect of Skio's card link; never in the page before that). "N points added" shows only once Skio itself
     marks the reward completed (Skio refetches its reward state when the tab gets focus back; we re-read Skio's
     card on focus / return). Email (newsletter list RHNWWp, single opt-in): "You're in!", no body. Texts (r6: the
     SMS list VxmYUP is double opt-in, Jim 2026-10-12): "Thanks!" and two conditional lines, because Klaviyo's 202
     does not prove that a confirmation text went out or that the number was new (never "sent" / "subscribed").
     Fail closed: no Klaviyo list id, no valid claim link, no points known, an older core, or any error
     -> the card keeps the r4 state (Not done yet), never Skio's claim link. Nothing typed is stored or logged. */
  var OPTIN = {
    'newsletter-signup': { channel: 'email', title: 'Join our newsletter', desc: 'Earn %p when you join our email newsletter.', icon: 'mail', other: 'sms-opt-in', cross: 'Join our newsletter' },
    'sms-opt-in': { channel: 'sms', title: 'Get texts from MK Supplements', desc: 'Earn %p when you sign up for marketing texts.', icon: 'phone', other: 'newsletter-signup', cross: 'Sign up for texts' }
  };
  /* r6 (C6): the points of a sign-up reward when Skio's card shows no number (MK's texts reward has its own title
     "Sign up for texts" and a description without the amount). Used only when neither the card's title nor its
     description has a digit; Skio's own number always wins. Must match Skio > Loyalty > Credits (texts 500:
     Cowork, Skio dashboard, 2026-10-12). null = unknown: the card stays Skio's own and reads "Not done yet". */
  var OPTIN_POINTS = { 'newsletter-signup': null, 'sms-opt-in': 500 };
  /* r6 (C3): the word Klaviyo's SMS confirmation text asks for (verify in Klaviyo > Settings > SMS before release) */
  var SMS_CONFIRM_REPLY = 'Y';
  /* r6 review: the store's name in the pop-up's copy; brand() wraps every occurrence in a nowrap span (widgets.css
     .mk-nw), so no line ends in "MK" alone. The text (textContent) stays exactly the same. */
  var BRAND = 'MK Supplements';
  function brand(str) {
    var out = [];
    String(str).split(BRAND).forEach(function (part, i) {
      if (i) out.push(E('span', { 'class': 'mk-nw', text: BRAND }));
      if (part) out.push(part);
    });
    return out;
  }
  /* the pop-up's title is set as text by the core; wrap the name in place (same text, same accessible name) */
  function brandTitle() {
    var t = document.querySelector('#mk-optin .mk-dlg-title');
    if (!t || t.querySelector('.mk-nw') || t.textContent.indexOf(BRAND) < 0) return;
    var nodes = brand(t.textContent);
    while (t.firstChild) t.removeChild(t.firstChild);
    nodes.forEach(function (n) { t.appendChild(typeof n === 'string' ? document.createTextNode(n) : n); });
  }
  var PRIVACY_URL = 'https://mksupps.com/policies/privacy-policy';
  /* -> {url: 'https://mksupps.com/pages/sms-terms', label: 'SMS Terms'} once that page is published (and SMS v2 in the core) */
  var SMS_TERMS = { url: 'https://mksupps.com/policies/terms-of-service', label: 'Terms of Service' };
  var CONTACT_URL = 'https://mksupps.com/pages/contact-us';
  var CLAIM_PATH = '/a/account/credits/claim';
  var CLAIM_HOSTS = /^(www\.)?mksupps\.com$/i;            /* the redirect Jim sets: https://mksupps.com/a/account/loyalty */
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  var CLAIM_WAIT_MS = 10000;                               /* after the customer is back: Skio's "completed" within this, else "Adding your points" */
  /* r9 (C9, option c, Jim 2026-10-15): "Claim points" claims in the pop-up (core 1.4.0 claimReward: Skio's own claim
     request, no new tab, no reload) whenever the core can send it (MKPortal.canClaim: the loader's claim switch on, the
     reward one of the claim guard's two ids, Klaviyo accepted that channel in this page view); else r6's claim step,
     exactly. false = r6's claim step always (the loader's switch mk_portal_write_claim is the owner's off switch) */
  var CLAIM_IN_PAGE = true;
  var NUDGE_AT = [0, 1500, 3500, 6000, 10000];             /* ms after Skio answered the claim: MKPortal.nudgeSkio() (Skio refetches its reward state) */
  var NUDGE_TAIL = [20000, 35000, 60000];                  /* r9 review: then a slow tail, only while Skio's card has not said Completed */
  var optinFlow = {};                                      /* per type, this visit only: {accepted, claim, clickedAt, back, done; r9: pending, sent, outcome, fallback, timer;
                                                              r9 review: uid = the login's storefrontUserId at the sign-up's press} */
  var optinUi = null;                                      /* the open pop-up: {type, step, h, ...} */
  function MK() {
    var M = window.MKPortal;
    return M && M.dialog && M.klaviyo && typeof M.dialog.open === 'function' && typeof M.el === 'function' ? M : null;
  }
  function ptsText(n) { return fmtNum(n) + (n === 1 ? ' point' : ' points'); }
  /* Skio's claim link on the card -> {id, redirect, href} when it is exactly Skio's: same origin, path
     /a/account/credits/claim, a uuid id and an https redirect on mksupps.com (or this host); else null */
  function claimLink(a) {
    try {
      var raw = a && a.getAttribute ? a.getAttribute('href') : '';
      if (!raw) return null;
      var u = new URL(raw, location.origin);
      if (u.origin !== location.origin || u.username || u.password || u.pathname.replace(/\/+$/, '') !== CLAIM_PATH) return null;
      var id = u.searchParams.get('id') || '', red = u.searchParams.get('redirect') || '';
      if (!UUID.test(id) || !red) return null;
      var r = new URL(red);
      if (r.protocol !== 'https:' || r.username || r.password || !(CLAIM_HOSTS.test(r.hostname) || r.hostname === location.hostname)) return null;
      return { id: id.toLowerCase(), redirect: r.href, href: location.origin + CLAIM_PATH + '?id=' + id.toLowerCase() + '&redirect=' + encodeURIComponent(r.href) };
    } catch (e) { return null; }
  }
  function isClaimHref(a) {
    try { return new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/+$/, '').slice(-14) === '/credits/claim'; } catch (e) { return false; }
  }
  function hideClaim(sk) {
    qa('a[href]', sk.act).forEach(function (a) {
      if (mine(a) || !isClaimHref(a)) return;
      if (a.style.getPropertyValue('display') !== 'none') a.style.setProperty('display', 'none', 'important');
      if (!a.hasAttribute('data-mk-claim-hidden')) a.setAttribute('data-mk-claim-hidden', '');
    });
  }
  /* our title and description on the two sign-up cards, over Skio's text nodes (as the tier prefix is
     stripped); the points come from Skio's own card (title "500 Points", else its description), else (r6) from
     OPTIN_POINTS when the card shows no number (optinPoints) */
  function setText(el, value) {
    if (text(el) === value) return;
    if (!el.__mkOrig) el.__mkOrig = text(el);
    var nodes = [], w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) nodes.push(n);
    if (!nodes.length) { el.appendChild(document.createTextNode(value)); return; }
    nodes.forEach(function (t, i) { var v = i === 0 ? value : ''; if (t.nodeValue !== v) t.nodeValue = v; });
  }
  function copyRestore(card) {
    ['credit-reward-points', 'credit-reward-description'].forEach(function (k) {
      var el = q('[data-skio-name="' + k + '"]', card);
      if (el && el.__mkOrig != null) { var o = el.__mkOrig; el.__mkOrig = null; setText(el, o); el.__mkOrig = null; }
    });
    qa('.mk-earn-ico', card).forEach(function (n) { n.remove(); });
    card.removeAttribute('data-mk-earn-copy');
    card.removeAttribute('data-mk-earn-pts');
    card.removeAttribute('data-mk-earn-pts-src');
  }
  /* r6 (C6): the points, first source that gives them: Skio's text on the card ("500 points" title, else
     "... 500 points ..." in the description) -> 'skio-text'; only when Skio shows no number at all, the owner
     setting -> 'owner'; else null (a number we cannot read is never overridden by our setting) */
  function optinPoints(type, ht, dt) {
    var m = /^(\d[\d,]{0,8})\s+points?$/i.exec(ht) || /\b(\d[\d,]{0,8})\s+points?\b/i.exec(dt);
    var n = m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
    if (n > 0 && n < 1000000) return { pts: n, src: 'skio-text' };
    if (m || /\d/.test(ht + ' ' + dt)) return null;
    n = OPTIN_POINTS[type];
    return typeof n === 'number' && n === Math.floor(n) && n > 0 && n < 1000000 ? { pts: n, src: 'owner' } : null;
  }
  function earnCopy(card, type) {
    var cp = OPTIN[type], h = q('[data-skio-name="credit-reward-points"]', card), d = q('[data-skio-name="credit-reward-description"]', card);
    if (!h || !d) return null;
    var ht = text(h), dt = text(d), pts = null, got;
    var ours = ht === cp.title && card.getAttribute('data-mk-earn-copy') === type;
    if (ours) pts = parseInt(card.getAttribute('data-mk-earn-pts'), 10);
    else {
      got = optinPoints(type, ht, dt);
      pts = got ? got.pts : null;
      if (got && card.getAttribute('data-mk-earn-pts-src') !== got.src) card.setAttribute('data-mk-earn-pts-src', got.src);
    }
    if (!(pts > 0 && pts < 1000000)) { copyRestore(card); return null; }
    if (card.getAttribute('data-mk-earn-pts') !== String(pts)) card.setAttribute('data-mk-earn-pts', String(pts));
    if (card.getAttribute('data-mk-earn-copy') !== type) card.setAttribute('data-mk-earn-copy', type);
    setText(h, cp.title);
    setText(d, cp.desc.replace('%p', ptsText(pts)));
    /* the texts card: a phone in place of Skio's pencil (Skio's stock icon only; an uploaded icon stays) */
    var box = type === 'sms-opt-in' ? q('[data-skio-name="credit-reward-icon"]', card) : null;
    if (box && !q('.mk-earn-ico', box)) box.appendChild(earnIcon('phone', 'mk-earn-ico'));
    return pts;
  }
  function optinOffer(type, sk, pts) {
    var M = MK();
    if (!M || !(pts > 0) || !M.klaviyo.ready(OPTIN[type].channel)) return null;
    var claim = claimLink(sk.link);
    return claim ? { pts: pts, claim: claim } : null;
  }
  /* the latest facts per type, for the pop-up (points, claim link, completed) */
  var optinCards = {};
  function optinNote(type, card, sk, pts) { optinCards[type] = { card: card, pts: pts, done: !!sk.done, claim: sk.link ? claimLink(sk.link) : null }; }
  function currentOffer(type) {
    var cards = qa('[data-skio-name="credit-rewards-grid"] > [data-skio-name="credit-reward-card"]').filter(function (c) { return earnType(c) === type; });
    var sk = cards[0] ? earnSkio(cards[0]) : null;
    if (!sk || sk.done || sk.unknown) return null;
    var pts = parseInt(cards[0].getAttribute('data-mk-earn-pts'), 10);
    return optinOffer(type, sk, pts);
  }

  /* profile (email / phone to pre-fill) and the codes: one read of Skio's own loyalty document */
  var profile = { email: null, phone: null, src: { email: null, phone: null }, read: '', tries: 0 };
  var PROFILE_TRIES = 3;                 /* r7: reads started by an opening pop-up, per page view */
  /* -> true when it filled the field (never over anything there or anything the customer typed); the value goes
     into the input's value only: no attribute, no storage, no log */
  function fill(input, value) {
    if (!input || !value || input.value || input.__mkTouched) return false;
    input.value = value;
    return true;
  }
  /* the account email to show: only one the core's check accepts (the same check as on Join newsletter) */
  function prefillEmail(v) {
    var K = window.MKPortal && window.MKPortal.klaviyo;
    return K && typeof v === 'string' ? K.validEmail(v) : null;
  }
  /* r7 review (2026-10-15): true while the field holds the account email (case aside). The hint "We'll use the email
     on your account" shows only then: it hides once the customer types another address and comes back if they type
     the account one again */
  function isAccountEmail(v) {
    var a = profile.email, e = prefillEmail(v);
    return !!(a && e && e.toLowerCase() === a.toLowerCase());
  }
  /* r7 (C10): fill the open sign-up form from what is known now (after every finished read, and at opening) */
  function prefillOpen() {
    var ui = optinUi;
    if (!ui || ui.step !== 'form' || !ui.h || !ui.h.isOpen()) return;
    var body = ui.h.body, e = document.getElementById('mk-optin-email'), p = document.getElementById('mk-optin-tel');
    if (e && body.contains(e) && fill(e, profile.email)) {
      var hint = document.getElementById('mk-optin-email-hint');
      if (hint) hint.hidden = !isAccountEmail(e.value);
    }
    if (p && body.contains(p)) fill(p, profile.phone);
    /* r7 (C10): this read did not get the customer (e.g. the login token came after it gave up) and the open form is
       still empty and untouched: read again (wantProfile: at most PROFILE_TRIES per page view) */
    var f = e && body.contains(e) ? e : p && body.contains(p) ? p : null;
    if (f && !f.value && !f.__mkTouched && profile.read !== 'ok') wantProfile();
  }
  /* r7 (C10): an opening pop-up with nothing to fill in: a read is running (it fills the form when it ends), or none
     ran yet, or the last one did not get the customer (no token yet, Skio's read failed): read again (at most
     PROFILE_TRIES per page view). A read that got the customer but no email / number is not repeated. */
  function wantProfile() {
    if (!window.MKPortal || codes.loading) return;
    if (codes.loaded && profile.read === 'ok') return;
    if (profile.tries >= PROFILE_TRIES) return;
    profile.tries++;
    loadCodes(false);
  }

  function optinOpen(type, ev) {
    var opener = ev && ev.currentTarget && ev.currentTarget.nodeType === 1 ? ev.currentTarget : null;
    var g = optinFlow[type];
    /* r9 review: a sign-up from this page view opens on the claim step only for the customer who signed up: look at the
       login first (no wait: the token is read now) */
    if (signedUpFlows(g)) {
      optinUserCheck().then(function () { if (!optinUi) optinShow(type, opener); }, function () { /* ignore */ });
      return;
    }
    optinShow(type, opener);
  }
  function optinShow(type, opener) {
    var M = MK();
    try {
      if (!M) { schedule(); return; }
      var offer = currentOffer(type);
      if (!offer) { schedule(); return; }     /* completed meanwhile, or no longer offered: the card updates */
      var f = optinFlow[type] || (optinFlow[type] = { accepted: false });
      f.pts = offer.pts;
      if (!f.claim || !f.accepted) f.claim = offer.claim;
      var h = M.dialog.open({
        id: 'mk-optin', module: 'rewards', className: 'mk-optin', title: OPTIN[type].title, opener: opener,
        returnFocus: function () { return q('[data-skio-name="credit-reward-action"] > button.mk-earn-state[data-mk-optin="' + type + '"]') || q('#mk-earn'); },
        onClose: function () { optinUi = null; schedule(); }
      });
      if (!h) { schedule(); return; }
      optinUi = { type: type, step: '', h: h };
      if (f.accepted) stepClaim(type); else stepForm(type);
    } catch (e) {
      try { if (optinUi && optinUi.h) optinUi.h.close('error'); } catch (e2) { /* ignore */ }
      optinUi = null;
    }
  }
  function E(tag, attrs) {
    var M = MK(), args = Array.prototype.slice.call(arguments);
    return M.el.apply(M, args);
  }
  function icon(name, cls) { return earnIcon(name, cls); }
  function sr(t) { return E('span', { 'class': 'mk-dlg-sr', text: t }); }
  function ghost(label, reason) {
    var b = E('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--ghost' }, label);
    b.addEventListener('click', function () { if (optinUi) optinUi.h.close(reason || 'not-now'); });
    return b;
  }
  function extLink(url, label) {
    return E('a', { href: url, target: '_blank', rel: 'noopener' }, label, sr(' (opens in a new tab)'));
  }
  function fieldMsg(id, msg) {
    var p = E('p', { 'class': 'mk-dlg-field-msg', id: id, role: 'alert' });
    p.appendChild(icon('alert'));
    p.appendChild(document.createTextNode(msg));
    return p;
  }
  /* the alert under the form: "<b>first sentence</b> <span>rest</span>" (+ a contact link) */
  function alertBox(id, head, rest, contact) {
    var d = E('div', null, E('b', { text: head }), ' ', E('span', null, rest, contact ? [' ', extLink(CONTACT_URL, 'contact us'), '.'] : null));
    var a = E('div', { 'class': 'mk-dlg-alert', id: id, role: 'alert' });
    a.appendChild(icon('alert'));
    a.appendChild(d);
    return a;
  }
  function errorCopy(channel, reason) {
    if (reason === 'bad_request') return [channel === 'sms' ? 'That number didn\'t go through.' : 'That email didn\'t go through.', 'Check it and try again.'];
    if (reason === 'rate_limited') return ['Too many tries.', 'Please wait a minute and try again.'];
    if (reason === 'refused') return [channel === 'sms' ? 'We couldn\'t sign you up for texts.' : 'We couldn\'t sign you up.', 'Please try again later or', true];
    return ['We couldn\'t sign you up just now.', 'Please try again.'];
  }
  function setDescribed(el, ids) { var v = ids.filter(Boolean).join(' '); if (v) el.setAttribute('aria-describedby', v); else el.removeAttribute('aria-describedby'); }

  /* step 1: the form (email or texts) */
  function stepForm(type) {
    var ui = optinUi, f = optinFlow[type], cp = OPTIN[type], sms = cp.channel === 'sms';
    if (!ui || ui.type !== type) return;
    var pts = E('b', { text: ptsText(f.pts) });
    var body = [], input, check, box, disc, slot = E('div', { 'class': 'mk-optin-slot' });
    var discId = sms ? 'mk-optin-sms-disc' : 'mk-optin-email-disc';
    if (!sms) {
      body.push(E('p', { 'class': 'mk-dlg-lead' }, brand('News, offers and new products from MK Supplements, by email. Join and earn '), pts, '.'));
      body.push(E('label', { 'class': 'mk-dlg-label', 'for': 'mk-optin-email' }, 'Email'));
      input = E('input', { 'class': 'mk-dlg-input', id: 'mk-optin-email', type: 'email', name: 'email' });
      input.setAttribute('autocomplete', 'email'); input.setAttribute('inputmode', 'email'); input.setAttribute('spellcheck', 'false'); input.setAttribute('autocapitalize', 'off');
      if (f.value) input.value = f.value; else fill(input, profile.email);
      body.push(input);
      var hint = E('p', { 'class': 'mk-dlg-hint', id: 'mk-optin-email-hint', text: 'We\'ll use the email on your account. You can change it.' });
      if (!isAccountEmail(input.value)) hint.hidden = true;
      body.push(hint);
      disc = E('p', { 'class': 'mk-dlg-legal mk-optin-email-legal', id: discId }, brand('By joining, you agree to receive marketing emails from MK Supplements. You can unsubscribe at any time using the link in any email. See our '), extLink(PRIVACY_URL, 'Privacy Policy'), '.');
      body.push(disc, slot);
      /* r7 (C10): not known yet -> the next finished read fills it (prefillOpen) */
    } else {
      body.push(E('p', { 'class': 'mk-dlg-lead' }, 'Offers and product news by text. Join and earn ', pts, '.'));
      body.push(E('label', { 'class': 'mk-dlg-label', 'for': 'mk-optin-tel' }, 'Mobile number'));
      input = E('input', { 'class': 'mk-dlg-input', id: 'mk-optin-tel', type: 'tel', name: 'tel' });
      input.setAttribute('autocomplete', 'tel-national'); input.setAttribute('inputmode', 'tel');
      if (f.value) input.value = window.MKPortal.klaviyo.formatPhone(f.value) || f.value; else fill(input, profile.phone);
      body.push(input, E('p', { 'class': 'mk-dlg-hint', id: 'mk-optin-tel-hint', text: 'US mobile numbers only.' }));
      /* data-mk-consent="sms": the core records this box's state in the click's token and sends no SMS sign-up without it */
      box = E('input', { type: 'checkbox', id: 'mk-optin-consent', name: 'consent', 'data-mk-consent': 'sms' });
      if (f.consent) box.checked = true;
      check = E('label', { 'class': 'mk-dlg-check', 'for': 'mk-optin-consent' }, box, E('span', { 'class': 'mk-dlg-box' }, icon('check')), E('span', null, brand('Yes, text me marketing messages from MK Supplements.')));
      body.push(check);
      disc = E('p', { 'class': 'mk-dlg-legal', id: discId }, brand('Optional. By checking this box and pressing Sign up for texts, you agree to receive recurring marketing text messages (such as offers and cart reminders) from MK Supplements at the number above, including messages sent by autodialer. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Reply HELP for help, STOP to cancel. See our '),
        extLink(PRIVACY_URL, 'Privacy Policy'), ' and ', extLink(SMS_TERMS.url, SMS_TERMS.label), '.');
      body.push(disc, slot);
      setDescribed(box, [discId]);
      box.addEventListener('change', function () { f.consent = box.checked; if (box.checked) clearMsg(check, box, 'mk-optin-check-msg', [discId]); });
      input.addEventListener('blur', function () { var fm = window.MKPortal.klaviyo.formatPhone(input.value); if (fm) input.value = fm; });
    }
    input.addEventListener('input', function () {
      input.__mkTouched = true;
      clearMsg(null, input, input.id + '-msg', [input.id + '-hint']);
      /* r7 review: the account-email hint only while the field holds that email */
      var h = sms ? null : document.getElementById('mk-optin-email-hint');
      if (h) h.hidden = !isAccountEmail(input.value);
    });
    setDescribed(input, [input.id + '-hint']);
    var go = E('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary mk-optin-go' }, sms ? 'Sign up for texts' : 'Join newsletter');
    setDescribed(go, [discId]);
    go.addEventListener('click', function (ev) { optinSubmit(type, ev, { input: input, box: box, check: check, slot: slot, go: go, discId: discId }); });
    ui.step = 'form';
    ui.h.set({ icon: E('div', { 'class': 'mk-dlg-icon' }, icon(cp.icon)), title: cp.title, body: body, actions: [go, ghost('Not now')], pin: !sms, center: false, stack: false, describedBy: null });
    brandTitle();
    /* r7 (C10): nothing to fill in yet: make sure a read that can get the customer runs (it fills the form when it ends) */
    if (!input.value) wantProfile();
  }
  function clearMsg(row, field, msgId, keep) {
    var m = document.getElementById(msgId);
    if (m) m.remove();
    if (row) row.classList.remove('is-invalid');
    field.removeAttribute('aria-invalid');
    setDescribed(field, keep);
  }
  function badField(row, field, msgId, msg, keep, after) {
    var m = document.getElementById(msgId);
    if (!m) { m = fieldMsg(msgId, msg); (after || row || field).insertAdjacentElement('afterend', m); }
    if (row) row.classList.add('is-invalid');
    field.setAttribute('aria-invalid', 'true');
    setDescribed(field, [msgId].concat(keep));
  }
  function optinSubmit(type, ev, p) {
    var ui = optinUi, M = MK(), f = optinFlow[type], sms = OPTIN[type].channel === 'sms';
    if (!ui || ui.type !== type || ui.step !== 'form' || !M || ui.h.isBusy()) return;
    var ok = true, value, firstBad = null;
    if (sms) {
      value = M.klaviyo.normalizePhone(p.input.value);
      if (!value) { ok = false; firstBad = p.input; badField(null, p.input, 'mk-optin-tel-msg', 'Enter a 10-digit US mobile number.', ['mk-optin-tel-hint'], document.getElementById('mk-optin-tel-hint')); }
      else clearMsg(null, p.input, 'mk-optin-tel-msg', ['mk-optin-tel-hint']);
      if (!p.box.checked) { ok = false; firstBad = firstBad || p.box; badField(p.check, p.box, 'mk-optin-check-msg', 'Check the box to agree to texts.', [p.discId]); }
    } else {
      value = M.klaviyo.validEmail(p.input.value);
      if (!value) { ok = false; firstBad = p.input; badField(null, p.input, 'mk-optin-email-msg', 'Enter a valid email address.', ['mk-optin-email-hint'], document.getElementById('mk-optin-email-hint')); }
      else clearMsg(null, p.input, 'mk-optin-email-msg', ['mk-optin-email-hint']);
    }
    var old = document.getElementById('mk-optin-alert');
    if (old) old.remove();
    setDescribed(p.go, [p.discId]);
    if (!ok) {                                   /* nothing is sent */
      try { firstBad.focus({ preventScroll: true }); ui.h.reveal(document.getElementById(firstBad === p.box ? 'mk-optin-check-msg' : p.input.id + '-msg') || firstBad); } catch (e) { /* ignore */ }
      return;
    }
    /* the customer's own press, now: a single-use confirmation for exactly this channel */
    var tok = ui.h.confirm(ev, { kind: 'klaviyo', channel: OPTIN[type].channel });
    if (!tok) return;                            /* a double press, or the dialog is busy */
    ui.h.busy(true);
    var label = p.go.textContent;
    p.go.textContent = sms ? 'Signing you up\u2026' : 'Joining\u2026';
    p.go.setAttribute('aria-disabled', 'true');
    /* r9 review: whose sign-up this is (the login at the press) */
    var uidAt = loginNow();
    var req = sms ? M.klaviyo.subscribeSms(value, { consent: p.box.checked === true, confirm: tok, email: profile.email || undefined })
      : M.klaviyo.subscribeEmail(value, { confirm: tok });
    Promise.resolve(req).then(function (r) {
      r = r || { ok: false, reason: 'error' };
      return r.ok ? Promise.all([uidAt, loginNow()]).then(function (u) { return { r: r, at: u[0], now: u[1] }; }) : { r: r };
    }).then(function (x) {
      var r = x.r;
      /* r9 review: another customer logged in while Klaviyo answered (Skio's logout / login need no page load): the
         sign-up is not this customer's, so no claim step for them (the pop-up closes, the card says Sign up) */
      if (r.ok && x.at !== x.now) {
        delete optinFlow[type];
        if (optinUi === ui && ui.h.isOpen()) { ui.h.busy(false); ui.h.close('customer-changed'); }
        schedule();
        return;
      }
      if (r.ok) { f.accepted = true; f.uid = x.at; f.value = value; f.consent = sms ? true : f.consent; userWatch(); }
      if (optinUi !== ui || !ui.h.isOpen()) { schedule(); return; }
      ui.h.busy(false);
      p.go.textContent = label;
      p.go.removeAttribute('aria-disabled');
      if (r.ok) { stepClaim(type); schedule(); return; }
      if (r.reason === 'busy' || r.reason === 'not_confirmed') return;
      if (r.reason === 'invalid_phone') { badField(null, p.input, 'mk-optin-tel-msg', 'Enter a 10-digit US mobile number.', ['mk-optin-tel-hint'], document.getElementById('mk-optin-tel-hint')); return; }
      if (r.reason === 'invalid_email') { badField(null, p.input, 'mk-optin-email-msg', 'Enter a valid email address.', ['mk-optin-email-hint'], document.getElementById('mk-optin-email-hint')); return; }
      if (r.reason === 'consent_required') { badField(p.check, p.box, 'mk-optin-check-msg', 'Check the box to agree to texts.', [p.discId]); return; }
      var c = errorCopy(OPTIN[type].channel, r.reason);
      var a = alertBox('mk-optin-alert', c[0], c[1], c[2]);
      p.slot.appendChild(a);
      setDescribed(p.go, ['mk-optin-alert', p.discId]);
      ui.h.reveal(a);
    });
  }
  /* r9 review (customer change): the login's storefrontUserId now, without waiting (no token now: null). Ids only,
     never the token; nothing stored */
  function loginNow() {
    try {
      var M = window.MKPortal;
      if (!M || typeof M.storefrontUserId !== 'function') return Promise.resolve(null);
      return Promise.resolve(M.storefrontUserId({ timeout: 0 })).then(function (u) { return typeof u === 'string' ? u.toLowerCase() : null; }, function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  /* a sign-up accepted in this page view belongs to the customer logged in at its press (f.uid). Skio's logout and
     login are client-side (no page load): when another customer is logged in, everything of that sign-up is forgotten
     (also after its claim was sent or Completed: its waiting step's new-tab link would claim for whoever is logged in),
     so their card says Sign up and the pop-up opens on the form (never the claim step, never Skio's claim link). A
     moment with no login token (a token refresh) changes nothing. A claim on its way is left alone until it ends (the
     core checks the customer itself before sending). -> Promise<true when every sign-up is this customer's> */
  var userCheck = null;
  function signedUpFlows(f) { return !!f && f.accepted === true && !f.pending; }
  function optinUserCheck() {
    if (userCheck) return userCheck;
    if (!Object.keys(optinFlow).some(function (t) { return signedUpFlows(optinFlow[t]); })) return Promise.resolve(true);
    userCheck = loginNow().then(function (u) {
      userCheck = null;
      var changed = false;
      if (u) {
        Object.keys(optinFlow).forEach(function (t) {
          var f = optinFlow[t];
          if (signedUpFlows(f) && f.uid !== u) {
            changed = true;
            if (f.timer) clearTimeout(f.timer);
            delete optinFlow[t];
            if (optinUi && optinUi.type === t) optinUi.h.close('customer-changed');
          }
        });
      }
      if (changed) schedule();
      return !changed;
    });
    return userCheck;
  }
  /* while a sign-up's points are not in yet (no Completed): look at the login every USER_POLL_MS (a logout / login in
     this tab without a route change, or in another tab); stops when none is left. Route changes, storage events, every
     sync of the cards and every opening look too */
  var USER_POLL_MS = 1000, userTimer = null;
  function userWatch() {
    if (userTimer) return;
    userTimer = setInterval(function () {
      if (!Object.keys(optinFlow).some(function (t) { var f = optinFlow[t]; return signedUpFlows(f) && !f.done; })) { clearInterval(userTimer); userTimer = null; return; }
      optinUserCheck();
    }, USER_POLL_MS);
  }

  /* step 2: only after Klaviyo accepted. Skio's claim link for this reward, in a new tab (Skio's own way).
     Email: "You're in!", no body. Texts (r6, double opt-in): "Thanks!" and two conditional lines (a 202 proves
     no text and no subscription; nothing here says one was sent, and the number is not shown) */
  function claimTitle(type, f) { return (OPTIN[type].channel === 'sms' ? 'Thanks! Claim your ' : 'You\'re in! Claim your ') + ptsText(f.pts); }
  function claimBody(type) {
    var body = [];
    if (OPTIN[type].channel === 'sms') {
      body.push(E('p', { 'class': 'mk-dlg-lead mk-optin-confirm', id: 'mk-optin-confirm' }, brand('If you\'re new to our texts, look for a text from MK Supplements asking you to confirm. Reply '),
        E('b', { text: SMS_CONFIRM_REPLY }), ' to it to start getting texts.'));
      body.push(E('p', { 'class': 'mk-dlg-hint', text: 'Already get our texts? There\'s nothing more to do.' }));
    }
    return body;
  }
  function stepClaim(type) {
    var ui = optinUi, f = optinFlow[type];
    if (!ui || ui.type !== type || !f || !f.accepted) return;
    if (!f.claim) { ui.h.close('no-claim'); return; }   /* cannot happen: offered only with a valid claim link */
    /* r9 (C9): in place. Sent already in this page view and Skio has not said Completed: "Adding your points" (the
       pressed button while the wait timer f.timer runs, i.e. until CLAIM_WAIT_MS after the press; it then moves an open
       pop-up on), afterwards the waiting step with the new-tab link. r9 review: decided by the timer, not by clickedAt
       (the new-tab link's click must never bring back a spinner that nothing moves on) */
    if (f.sent) { if (f.timer) stepClaimInPage(type, true); else stepWaiting(type, true); return; }
    if (f.pending || claimInPage(f)) { stepClaimInPage(type, !!f.pending); return; }
    var a = E('a', { 'class': 'mk-dlg-btn mk-dlg-btn--gold mk-optin-claim', href: f.claim.href, target: '_blank', rel: 'noopener' }, 'Claim points', icon('out'), sr(' (opens in a new tab)'));
    if (!a.getAttribute('href')) { ui.h.close('no-claim'); return; }
    a.addEventListener('click', function () { f.clickedAt = Date.now(); f.back = 0; });
    var sms = OPTIN[type].channel === 'sms', body = claimBody(type);
    ui.step = 'claim';
    ui.h.set({ icon: E('div', { 'class': 'mk-dlg-icon mk-dlg-icon--gold' }, icon('star')), title: claimTitle(type, f), body: body,
      actions: [a, E('p', { 'class': 'mk-dlg-after', text: 'Opens in a new tab. Come back to this tab to see your points.' })], pin: true, center: true, stack: true, describedBy: sms ? 'mk-optin-confirm' : null });
  }
  /* r9 (C9): the core can send the claim in place now (checks that need no click and no login token; the rest it
     checks itself when pressed). An older core (no claimReward / canClaim / nudgeSkio), CLAIM_IN_PAGE false or a
     claim that could not be sent in this page view (f.fallback): no */
  function claimInPage(f) {
    try {
      var M = window.MKPortal;
      return CLAIM_IN_PAGE === true && !!f && !!f.claim && !f.fallback && !!M && typeof M.claimReward === 'function' && typeof M.canClaim === 'function'
        && typeof M.nudgeSkio === 'function' && M.canClaim(f.claim.id) === true;
    } catch (e) { return false; }
  }
  /* r9 (C9): the claim step in place: the same title and texts lines, a gold <button> "Claim points" (no new-tab icon, no
     "Opens in a new tab" line) and a polite live region; adding = the pressed state ("Adding your points...", spinner) */
  function stepClaimInPage(type, adding) {
    var ui = optinUi, f = optinFlow[type], sms = OPTIN[type].channel === 'sms';
    if (!ui || ui.type !== type || !f) return;
    var b = E('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--gold mk-optin-claim mk-optin-claim--inpage' }, 'Claim points');
    var live = E('p', { 'class': 'mk-dlg-sr', id: 'mk-optin-live', 'aria-live': 'polite' });
    b.addEventListener('click', function (ev) { claimPress(type, ev, b, live); });
    ui.step = adding ? 'adding' : 'claim';
    ui.h.set({ icon: E('div', { 'class': 'mk-dlg-icon mk-dlg-icon--gold' }, icon('star')), title: claimTitle(type, f), body: claimBody(type),
      actions: [b, live], pin: true, center: true, stack: true, describedBy: sms ? 'mk-optin-confirm' : null });
    if (adding) claimLabel(b, true);
  }
  /* the button's two looks: "Claim points" / (pressed) spinner + "Adding your points..." with aria-disabled (it keeps
     focus; the live region says it once) */
  function claimLabel(b, adding, live) {
    while (b.firstChild) b.removeChild(b.firstChild);
    if (adding) {
      var sp = E('span', { 'class': 'mk-optin-spin', 'aria-hidden': 'true' });
      b.appendChild(sp);
      b.appendChild(document.createTextNode('Adding your points\u2026'));
      b.setAttribute('aria-disabled', 'true');
      try {
        if (sp.animate && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) sp.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 800, iterations: Infinity });
      } catch (e) { /* a still ring */ }
    } else {
      b.appendChild(document.createTextNode('Claim points'));
      b.removeAttribute('aria-disabled');
    }
    if (live) live.textContent = adding ? 'Adding your points' : '';
  }
  /* the press: a single-use confirmation from this real click (key 'claim:' + id), then ONE claimReward(). Nothing
     says "added" here: only Skio's own card (optinWatch -> stepClaimed) */
  function claimPress(type, ev, b, live) {
    var ui = optinUi, f = optinFlow[type], M = window.MKPortal;
    if (!ui || ui.type !== type || ui.step !== 'claim' || !f || !f.claim || f.pending || f.sent || !M || ui.h.isBusy()) return;
    var tok = ui.h.confirm(ev, { kind: 'claim', rewardId: f.claim.id });
    if (!tok) return;                            /* a double press, not a real click, or the dialog is busy */
    ui.h.busy(true);
    f.pending = true; f.clickedAt = Date.now(); f.back = 0;
    ui.step = 'adding';
    claimLabel(b, true, live);
    var p;
    try { p = M.claimReward({ rewardId: f.claim.id, confirm: tok }); } catch (e) { p = null; }
    Promise.resolve(p).then(function (r) { claimDone(type, ui, b, live, r && typeof r === 'object' ? r : { sent: false, reason: 'error' }); },
      function () { claimDone(type, ui, b, live, { sent: false, reason: 'error' }); });
  }
  function claimDone(type, ui, b, live, r) {
    var f = optinFlow[type];
    if (!f) return;
    f.pending = false;
    var open = optinUi === ui && ui.h.isOpen();
    if (open) ui.h.busy(false);
    if (r.sent !== true) {
      f.clickedAt = 0;
      /* nothing was sent and a new press can try again (another write was running, or the press was not confirmed) */
      if (r.reason === 'busy' || r.reason === 'not_confirmed') {
        if (open && ui.step === 'adding') { ui.step = 'claim'; claimLabel(b, false, live); }
        else claimReopen(type, ui);
        return;
      }
      /* r9 review: the core refused because the customer logged in now is not the one Klaviyo accepted (a logout /
         login without a page load): never a claim link for them. That sign-up is forgotten: the form (or the pop-up
         closes when the reward is no longer offered); the card says Sign up */
      if (r.reason === 'not_signed_up') {
        delete optinFlow[type];                  /* everything of that sign-up (its address too) */
        var now = currentOffer(type), cur = optinUi && optinUi.type === type && optinUi.h.isOpen() ? optinUi : null;
        if (cur && now) { optinFlow[type] = { accepted: false, pts: now.pts, claim: now.claim }; stepForm(type); }
        else if (cur) cur.h.close('no-claim');
        schedule();
        return;
      }
      /* nothing was sent and nothing will be in this page view (switch off, no login token, ...): r6's claim step */
      f.fallback = true;
      if (open) stepClaim(type); else claimReopen(type, ui);
      schedule();
      return;
    }
    /* sent (any answer, or none): Skio refetches its own reward state on our nudges; "added" only once its card says Completed */
    f.sent = true;
    f.outcome = typeof r.outcome === 'string' ? r.outcome : 'unknown';
    NUDGE_AT.concat(NUDGE_TAIL).forEach(function (ms, i) {
      setTimeout(function () {
        if (i >= NUDGE_AT.length && f.done) return;
        try { if (window.MKPortal && typeof window.MKPortal.nudgeSkio === 'function') window.MKPortal.nudgeSkio(); } catch (e) { /* ignore */ }
        schedule();
      }, ms);
    });
    if (f.timer) clearTimeout(f.timer);
    f.timer = setTimeout(function () {
      f.timer = null;
      tick();
      var u = optinUi;
      if (u && u.type === type && u.step === 'adding' && !f.done) stepWaiting(type, true);
    }, Math.max(0, CLAIM_WAIT_MS - (Date.now() - f.clickedAt)));
    if (!open) claimReopen(type, ui);
    schedule();
  }
  /* the pop-up was closed and opened again while the claim was on its way: show the current state there */
  function claimReopen(type, ui) {
    var cur = optinUi;
    if (cur && cur !== ui && cur.type === type && cur.h.isOpen() && /^(claim|adding)$/.test(cur.step)) stepClaim(type);
  }
  /* Skio has not reported it yet (CLAIM_WAIT_MS after the customer came back): never "added" before Skio says so.
     r9 (C9) link: after a claim sent in place, a secondary "Not showing up? Claim in a new tab" = r6's claim link for
     this reward (safe: Skio refuses a second claim of a reward, Cowork L3 2026-10-13) */
  function stepWaiting(type, link) {
    var ui = optinUi, f = optinFlow[type];
    if (!ui || ui.type !== type) return;
    ui.step = 'waiting';
    var done = E('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary' }, 'Done');
    done.addEventListener('click', function () { if (optinUi) optinUi.h.close('done'); });
    var body = [E('p', { 'class': 'mk-dlg-lead', text: 'This can take a moment. Your balance and this card will update when they\'re in.' })];
    if (link && f && f.claim && f.claim.href) {
      var a = E('a', { 'class': 'mk-optin-fallback', href: f.claim.href, target: '_blank', rel: 'noopener' }, 'Claim in a new tab', sr(' (opens in a new tab)'));
      /* clickedAt stays the press's (optinWatch only needs it set); the waiting step stays as it is */
      a.addEventListener('click', function () { f.back = 0; });
      body.push(E('p', { 'class': 'mk-dlg-hint mk-optin-fallback-line' }, 'Not showing up? ', a));
    }
    ui.h.set({ icon: E('div', { 'class': 'mk-dlg-icon mk-dlg-icon--gold' }, icon('star')), title: 'Adding your points',
      body: body, actions: [done], pin: true, center: true, stack: false, describedBy: null });
  }
  /* step 3: only once Skio's own card says completed */
  function stepClaimed(type) {
    var ui = optinUi, f = optinFlow[type], cp = OPTIN[type];
    if (!ui || ui.type !== type) return;
    ui.step = 'claimed';
    var body = [E('p', { 'class': 'mk-dlg-lead', text: 'They\'re in your points balance now.' })];
    /* r6 (texts, double opt-in): above the cross-sell, so the cross-sell stays right above Done */
    if (cp.channel === 'sms') body.push(E('p', { 'class': 'mk-dlg-hint' }, 'New to our texts? Reply ', E('b', { text: SMS_CONFIRM_REPLY }), ' to the confirmation text to start getting them.'));
    var other = cp.other, oo = currentOffer(other), of = optinFlow[other];
    if (oo && !(of && of.accepted)) {
      var x = E('button', { type: 'button', 'class': 'mk-optin-xlink' }, OPTIN[other].cross);
      x.addEventListener('click', function () {
        var g = optinFlow[other] || (optinFlow[other] = { accepted: false });
        var now = currentOffer(other);
        if (!now || !optinUi) { schedule(); return; }
        g.pts = now.pts; g.claim = now.claim;
        optinUi.type = other;
        stepForm(other);
      });
      body.push(E('p', { 'class': 'mk-dlg-cross' }, 'Want ' + fmtNum(oo.pts) + ' more? ', x));
    }
    var done = E('button', { type: 'button', 'class': 'mk-dlg-btn mk-dlg-btn--primary' }, 'Done');
    done.addEventListener('click', function () { if (optinUi) optinUi.h.close('done'); });
    ui.h.set({ icon: E('div', { 'class': 'mk-dlg-icon mk-dlg-icon--done' }, icon('check')), title: ptsText(f.pts) + ' added', body: body, actions: [done], pin: true, center: true, stack: false, describedBy: null });
  }
  /* after every sync: Skio's card for a claimed type now says completed -> "N points added" (only after the
     customer pressed Claim points in this visit); the customer is back but Skio is silent -> "Adding your points" */
  var waitTimer = null;
  function optinWatch(info) {
    Object.keys(optinFlow).forEach(function (type) {
      var f = optinFlow[type], c = optinCards[type];
      if (!f.accepted || f.done) return;
      if (c && c.done && c.card && c.card.isConnected) {
        f.done = true;
        if (optinUi && optinUi.type === type && f.clickedAt && /^(claim|adding|waiting)$/.test(optinUi.step)) stepClaimed(type);
      }
    });
  }
  function optinBack() {
    /* the customer came back to this tab (Skio refetches its reward state on focus): read Skio's cards again */
    schedule();
    var ui = optinUi;
    if (!ui || ui.step !== 'claim') return;
    var f = optinFlow[ui.type];
    if (!f || !f.clickedAt || f.done) return;
    if (waitTimer) clearTimeout(waitTimer);
    waitTimer = setTimeout(function () {
      waitTimer = null;
      tick();
      var u = optinUi, g = u && optinFlow[u.type];
      if (u && u.step === 'claim' && g && g.clickedAt && !g.done) stepWaiting(u.type);
    }, CLAIM_WAIT_MS);
  }

  /* ---- 7. Your codes (batch 3): the customer's points codes from Skio (CreditDiscounts), under the points and
     redeem block. Unused: code, Copy, "$X off one order" (+ " - No expiry date" only with CODES_NO_EXPIRY: Jim
     checked MKPOINTS-GOJLQ1OF in Shopify: no end date; but the store's Rewards terms say codes expire 24 hours
     after they are made and Skio removes them, so r6 leaves it off). Past codes collapsed: "Used" (Skio's
     orderId) / "Expired, points refunded" (Skio's removedAt). r6 (Cowork R9, 8b-24): Skio's code expiry (24 h)
     removes an unredeemed code and refunds its points, so a customer who made a code and did not use it soon
     has past codes only; with CODES_PAST_ONLY the card then shows "You have no unused codes right now." and
     Past codes (collapsed), no Copy. Hidden when there are no codes at all, when Skio's own (unused codes) read
     fails, on any error and with the gate closed; never from a cache or storage (the core caches in memory
     only, and a redeem refetches fresh). Codes never go into links, attributes, storage or logs. ---- */
  var CODES_NO_EXPIRY = false;
  var CODES_PAST_ONLY = true;              /* false: hidden unless there is an unused code (batch 3) */
  var CODES_NONE_TEXT = 'You have no unused codes right now.';
  var CODES_MAX = 20;
  /* Skio's own loyalty document (portal bundle, 4707), verbatim: unused codes plus email / phone */
  var Q_LOYALTY = 'query storefrontUserLoyaltyInfo($storefrontUserId: uuid!) {\n  StorefrontUserByPk(id: $storefrontUserId) {\n    birthday\n    email\n    phoneNumber\n    firstName\n    lastName\n    createdAt\n    Tags {\n      id\n      Tag {\n        id\n        name\n      }\n    }\n    StorefrontUserTiers(\n      where: {removedAt: {_is_null: true}}\n      order_by: {createdAt: desc_nulls_last}\n    ) {\n      joinDate\n      tierExpiresAt\n      TierLevel {\n        id\n        name\n        iconUrl\n      }\n    }\n    CreditDiscounts(where: {removedAt: {_is_null: true}, orderId: {_is_null: true}}) {\n      code\n      amount\n      orderId\n      removedAt\n    }\n  }\n}';
  /* the past ones: the same fields, used or removed (a failure here only drops "Past codes") */
  var Q_PAST = 'query mkRewardPastCodes($storefrontUserId: uuid!) {\n  StorefrontUserByPk(id: $storefrontUserId) {\n    CreditDiscounts(where: {_or: [{orderId: {_is_null: false}}, {removedAt: {_is_null: false}}]}) {\n      code\n      amount\n      orderId\n      removedAt\n    }\n  }\n}';
  var codes = { seq: 0, loading: false, loaded: false, active: null, past: [], pastOpen: false, redeemSeen: '', retry: 0, el: null, sig: '' };
  function codeRows(list, past) {
    if (!Array.isArray(list)) return null;
    var out = [], seen = {};
    list.forEach(function (d) {
      if (!d || typeof d !== 'object') return;
      var code = typeof d.code === 'string' ? d.code.trim() : '';
      if (!/^[A-Za-z0-9][A-Za-z0-9_-]{2,59}$/.test(code) || seen[code.toUpperCase()]) return;
      var used = d.orderId != null && d.orderId !== '', gone = d.removedAt != null && d.removedAt !== '';
      if (!past && (used || gone)) return;
      if (past && !used && !gone) return;
      var amt = typeof d.amount === 'number' ? d.amount : (typeof d.amount === 'string' && /^\d+(\.\d+)?$/.test(d.amount) ? parseFloat(d.amount) : NaN);
      seen[code.toUpperCase()] = 1;
      out.push({ code: code, amount: amt > 0 && amt < 100000 ? amt : null, state: used ? 'Used' : gone ? 'Expired, points refunded' : '' });
    });
    return out.slice(0, CODES_MAX);
  }
  function loadCodes(fresh) {
    var M = window.MKPortal;
    if (!M || typeof M.skio !== 'function' || typeof M.storefrontUserId !== 'function') return Promise.resolve();
    var seq = ++codes.seq;
    codes.loading = true;
    var claimsMail = typeof M.claims === 'function' ? M.claims({ timeout: 8000 }).then(function (c) { return c && typeof c.email === 'string' ? c.email : null; }, function () { return null; }) : Promise.resolve(null);
    return (codes.p = M.storefrontUserId().then(function (uid) {
      if (!uid) return [null, null, null];
      var o = { fresh: !!fresh };
      return Promise.all([M.skio(Q_LOYALTY, { storefrontUserId: uid }, o), M.skio(Q_PAST, { storefrontUserId: uid }, o), claimsMail]);
    }).then(function (rs) {
      if (seq !== codes.seq) return;
      codes.loading = false;
      codes.loaded = true;
      var a = rs[0], p = rs[1];
      var u = a && !a.errors && a.data && a.data.StorefrontUserByPk && typeof a.data.StorefrontUserByPk === 'object' ? a.data.StorefrontUserByPk : null;
      var pu = p && !p.errors && p.data && p.data.StorefrontUserByPk && typeof p.data.StorefrontUserByPk === 'object' ? p.data.StorefrontUserByPk : null;
      var K = M.klaviyo;
      /* r7 (C10): Skio's email first, else the login token's; each with its source (for prefill(), never the value) */
      var se = u ? prefillEmail(u.email) : null, te = se ? null : prefillEmail(rs[2]);
      profile.email = se || te || null;
      profile.src.email = se ? 'skio' : te ? 'token' : null;
      profile.phone = u && K && u.phoneNumber ? (K.formatPhone(String(u.phoneNumber)) || null) : null;
      profile.src.phone = profile.phone ? 'skio' : null;
      profile.read = u ? 'ok' : rs[0] ? 'failed' : 'nouser';   /* rs[0] null: no customer id in the token (yet) */
      codes.active = u ? codeRows(u.CreditDiscounts, false) : null;
      codes.past = pu ? (codeRows(pu.CreditDiscounts, true) || []) : [];
      codes.pastFailed = !pu;                  /* r6: for the live check's counts (Cowork R9: refused filter or no past codes?) */
      try { prefillOpen(); } catch (e) { /* ignore */ }
      schedule();
    }, function () { if (seq === codes.seq) { codes.loading = false; codes.loaded = true; codes.active = null; codes.pastFailed = true; profile.read = 'failed'; schedule(); } }));
  }
  function codesRemove() {
    var el = document.getElementById('mk-codes');
    if (el) el.remove();
    codes.el = null; codes.sig = '';
  }
  function codesReset() {
    codes.seq++; codes.loading = false; codes.loaded = false; codes.active = null; codes.past = []; codes.redeemSeen = ''; codes.retry = 0; codesRemove();
    /* r7 (C10): a route change (Skio's logout is one) forgets the email / number; the next read brings them back */
    profile.email = null; profile.phone = null; profile.src.email = null; profile.src.phone = null; profile.read = '';
  }
  function copyText(s) {
    try { if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(s).then(function () { return true; }, function () { return legacyCopy(s); }); } catch (e) { /* fall through */ }
    return Promise.resolve(legacyCopy(s));
  }
  function legacyCopy(s) {
    try {
      var t = document.createElement('textarea');
      t.value = s; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'; t.style.top = '0';
      document.body.appendChild(t); t.select();
      var ok = document.execCommand('copy');
      t.remove();
      return !!ok;
    } catch (e) { return false; }
  }
  function moneyOff(n) { return money(n) + ' off'; }
  function buildCodes(active, past) {
    var M = MK() || window.MKPortal;
    var el = M.el('section', { id: 'mk-codes', 'class': 'mk-w', 'aria-labelledby': 'mkc-title' });
    var live = M.el('p', { 'class': 'mkc-sr', 'aria-live': 'polite' });
    var list = M.el('ul', { 'class': 'mkc-list' });
    active.forEach(function (c, i) {
      /* the button is named "Copy code" and described by the row's own <code> (review fix: the code is in no attribute) */
      var codeId = 'mkc-code-' + i;
      var btn = M.el('button', { type: 'button', 'class': 'mkc-copy', 'aria-label': 'Copy code', 'aria-describedby': codeId });
      var lbl = M.el('span', { text: 'Copy' });
      btn.appendChild(icon('copy')); btn.appendChild(lbl);
      var timer = null;
      btn.addEventListener('click', function () {
        copyText(c.code).then(function (ok) {
          if (!ok) return;
          btn.classList.add('is-copied'); lbl.textContent = 'Copied';
          btn.replaceChild(icon('check'), btn.firstChild);
          live.textContent = ''; setTimeout(function () { live.textContent = 'Copied ' + c.code; }, 30);
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () { btn.classList.remove('is-copied'); lbl.textContent = 'Copy'; btn.replaceChild(icon('copy'), btn.firstChild); }, 2000);
        });
      });
      var meta = M.el('p', { 'class': 'mkc-meta' });
      if (c.amount != null) meta.appendChild(M.el('b', { text: moneyOff(c.amount) }));
      meta.appendChild(document.createTextNode((c.amount != null ? ' one order' : 'One order') + (CODES_NO_EXPIRY ? ' \u00b7 No expiry date' : '')));
      list.appendChild(M.el('li', { 'class': 'mkc-code' }, M.el('div', { 'class': 'mkc-top' }, M.el('code', { id: codeId, text: c.code }), btn), meta));
    });
    /* r6: past codes only -> no list and no Copy, the line says there is nothing to use */
    var card = active.length ? M.el('div', { 'class': 'mkc-card' }, M.el('p', { 'class': 'mkc-sub', text: 'Codes you made with your points. Copy one to use at checkout on mksupps.com.' }), list)
      : M.el('div', { 'class': 'mkc-card mkc-card--past-only' }, M.el('p', { 'class': 'mkc-sub', text: CODES_NONE_TEXT }));
    if (past.length) {
      var pl = M.el('ul', { 'class': 'mkc-past-list', id: 'mkc-past-list' });
      if (!codes.pastOpen) pl.hidden = true;
      past.forEach(function (c) {
        pl.appendChild(M.el('li', null, M.el('code', { text: c.code }), M.el('span', { text: (c.amount != null ? moneyOff(c.amount) + ' \u00b7 ' : '') + c.state })));
      });
      var pb = M.el('button', { type: 'button', 'class': 'mkc-past-btn', 'aria-expanded': codes.pastOpen ? 'true' : 'false', 'aria-controls': 'mkc-past-list' }, 'Past codes (' + past.length + ')');
      pb.appendChild(icon('chev'));
      pb.addEventListener('click', function () {
        codes.pastOpen = !codes.pastOpen;
        pb.setAttribute('aria-expanded', codes.pastOpen ? 'true' : 'false');
        pl.hidden = !codes.pastOpen;
      });
      card.appendChild(M.el('div', { 'class': 'mkc-past' }, pb, pl));
    }
    card.appendChild(live);
    el.appendChild(M.el('p', { 'class': 'mkc-eyebrow', id: 'mkc-title', role: 'heading', 'aria-level': '2', text: 'Your codes' }));
    el.appendChild(card);
    return el;
  }
  function syncCodes() {
    var section = q('[data-skio-name="tier-and-redeem-section"]');
    if (!section || !window.MKPortal || typeof window.MKPortal.el !== 'function') { if (document.getElementById('mk-codes')) codesRemove(); return; }
    if (!codes.loaded && !codes.loading) { loadCodes(false); return; }
    /* a code Skio just generated (its redeem box) that our list does not have yet: read again, fresh (3 tries) */
    var rp = q('[data-skio-name="redeem-card-discount-code-text-container"] p'), rc = rp ? text(rp).toUpperCase() : '';
    if (rc && rc !== codes.redeemSeen && !codes.loading) {
      var known = (codes.active || []).some(function (c) { return c.code.toUpperCase() === rc; });
      if (known) codes.redeemSeen = rc;
      else if (codes.retry < 3) {
        codes.retry++;
        var wait = codes.retry === 1 ? 0 : 2000;
        codes.loading = true;
        setTimeout(function () { loadCodes(true); }, wait);
      } else codes.redeemSeen = rc;
    }
    if (!rc && codes.redeemSeen) { codes.redeemSeen = ''; codes.retry = 0; }
    var active = codes.active, past = codes.past || [];
    /* active null = Skio's own read failed: hidden. No unused code: hidden, unless (r6) there are past codes */
    if (!active || !(active.length || (CODES_PAST_ONLY && past.length))) { if (document.getElementById('mk-codes')) codesRemove(); return; }
    var sig = JSON.stringify([active, past, CODES_NO_EXPIRY]);
    var el = document.getElementById('mk-codes');
    var parent = section.parentNode;
    if (el && el === codes.el && codes.sig === sig && el.parentNode === parent) return;
    var fresh = buildCodes(active, past);
    var tp = document.getElementById('mk-tier-progress');
    var hadFocus = el && el.contains(document.activeElement) ? (document.activeElement.className || '') : '';
    if (el) el.remove();
    /* after the tiers card in the DOM (the stylesheet's order puts it right under the points and redeem block),
       so the tiers card keeps its own place directly after Skio's section */
    var after = tp && tp.parentNode === parent ? tp : section;
    after.insertAdjacentElement('afterend', fresh);
    codes.el = fresh; codes.sig = sig;
    if (hadFocus) { var f = q(/mkc-past-btn/.test(hadFocus) ? '.mkc-past-btn' : '.mkc-copy', fresh); if (f) try { f.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }

  /* ---- 5. redeemed code: its length for the stylesheet (one line beside Copy) ---- */
  var CODE_MIN_PX = 12;
  function syncCode() {
    qa('[data-skio-name="redeem-card-discount-code-text-container"]').forEach(function (box) {
      var p = q('p', box), code = text(p), n = code.length;
      var v = n > 0 ? String(Math.max(6, Math.min(40, n))) : '';
      if (box.style.getPropertyValue('--mk-code-chars') !== v) {
        if (v) box.style.setProperty('--mk-code-chars', v); else box.style.removeProperty('--mk-code-chars');
      }
      fitCode(box, p, code);
    });
  }
  /* one line: measure the code against the field and step the size down until it fits (12 px floor);
     re-measured when the code, the field's width or the loaded fonts change */
  function fitCode(box, p, code) {
    if (!p || !code) { box.style.removeProperty('--mk-code-fit'); box.removeAttribute('data-mk-code-wrap'); box.removeAttribute('data-mk-code-tight'); box.__mkFit = ''; return; }
    var key = code + '|' + box.clientWidth + '|' + (document.fonts && document.fonts.status);
    if (box.__mkFit === key || box.clientWidth <= 0) return;
    box.__mkFit = key;
    box.removeAttribute('data-mk-code-wrap');
    box.removeAttribute('data-mk-code-tight');
    box.style.removeProperty('--mk-code-fit');
    function avail() { var cs = getComputedStyle(box); return box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0); }
    function over() { return Math.max(p.scrollWidth, p.getBoundingClientRect().width) > avail() + 0.5; }
    if (!over()) return;
    var size = parseFloat(getComputedStyle(p).fontSize) || 18;
    while (size > CODE_MIN_PX && over()) {
      size = Math.max(CODE_MIN_PX, Math.floor((size - 0.5) * 2) / 2);
      box.style.setProperty('--mk-code-fit', size + 'px');
    }
    if (over()) box.setAttribute('data-mk-code-tight', '');   /* 12 px: no letter-spacing, slimmer side padding */
    if (over()) box.setAttribute('data-mk-code-wrap', '');    /* still too long: wrap, never cut */
  }

  /* ---- version (r6): read-only, for the live checks (mk-live-tools: versions.widgets). Declared in this block,
     which tools/test_core.py checks by its markers; the rest of the file is still diffed against the approved
     source. Bump with every change to this file or mk-portal-widgets.css. codeCounts(): counts only, never a
     code: {loaded, unused (null = Skio's read failed), past, pastRead 'ok' | 'failed'}. r7 (C10) prefill(): sources
     only, never an email or a number: {read: 'ok' | 'failed' | 'nouser' | null (none finished since the last route
     change), email: 'skio' | 'token' | null, phone: 'skio' | null} ---- */
  var VERSION = '1.3.1';
  try {
    window.MKPortalWidgets = Object.freeze({
      version: VERSION,
      codeCounts: function () { return { loaded: !!codes.loaded, unused: codes.active ? codes.active.length : null, past: (codes.past || []).length, pastRead: codes.loaded ? (codes.pastFailed ? 'failed' : 'ok') : null }; },
      prefill: function () { return { read: profile.read || null, email: profile.email ? profile.src.email : null, phone: profile.phone ? profile.src.phone : null }; }
    });
  } catch (e) { /* ignore */ }

  function mountInto(parent, id, cls, html, sig, placeAfter) {
    var existing = document.getElementById(id);
    if (existing && existing.getAttribute('data-sig') === sig && existing.parentNode === parent && (!placeAfter || existing.previousElementSibling === placeAfter)) return;
    if (existing) existing.remove();
    var el = document.createElement('section');
    el.id = id; el.className = cls; el.setAttribute('data-sig', sig); el.innerHTML = html;
    if (placeAfter) placeAfter.insertAdjacentElement('afterend', el); else parent.insertAdjacentElement('afterbegin', el);
  }

  function mount() {
    var section = q('[data-skio-name="tier-and-redeem-section"]');
    var heroEl = document.getElementById('mk-hero'), tiersEl = document.getElementById('mk-tier-progress');
    if (!section) { if (heroEl) heroEl.remove(); if (tiersEl) tiersEl.remove(); return; }
    var d = readTiers();
    var h = readHero();
    var redeem = q('[data-skio-name="redeem-card"]'); if (redeem) redeem.id = 'mk-redeem';
    var earn = q('[data-skio-name="credit-rewards"]'); if (earn) earn.id = 'mk-earn';
    var card = q('[data-skio-name="tier-card"]');
    if (h && card) mountInto(card, 'mk-hero', 'mk-w', buildHero(h, d), JSON.stringify([h, d]), null);
    else if (heroEl) heroEl.remove();
    if (d) mountInto(section.parentNode, 'mk-tier-progress', 'mk-w', buildTiers(d), JSON.stringify(d), section);
    else if (tiersEl) tiersEl.remove();
  }

  var scheduled = false;
  function tick() {
    scheduled = false;
    if (!gateOn()) { try { codesRemove(); if (optinUi) optinUi.h.close('gate'); } catch (e) {} }
    if (!gateOn()) { ['mk-hero', 'mk-tier-progress'].forEach(function (id) { var w = document.getElementById(id); if (w) w.remove(); }); clearEarn(); return; }
    var root = document.getElementById('skio-root');
    if (!root) return;
    try { stripPrefix(root); } catch (e) {}
    try { mount(); } catch (e) { ['mk-hero', 'mk-tier-progress'].forEach(function (id) { var w = document.getElementById(id); if (w) w.remove(); }); }
    try { syncRedeem(); } catch (e) {}
    try { syncEarn(); } catch (e) { clearEarn(); }
    try { syncCode(); } catch (e) {}
    try { syncCodes(); } catch (e) { codesRemove(); }
  }
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(tick); }
  var startTries = 0;
  function start() {
    var root = document.getElementById('skio-root');
    /* Skio did not load: stop looking after about 30 s */
    if (!root) { if (++startTries < 100) setTimeout(start, 300); return; }
    schedule();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#mk-tier-progress, #mk-hero')) continue;
        if (t && t.closest && t.closest('#mk-codes')) continue;
        schedule(); return;
      }
    }).observe(root, { childList: true, subtree: true, characterData: true });
    /* the code's fit depends on the field's width and on the font (Rubik may load after Skio) */
    window.addEventListener('resize', schedule, { passive: true });
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule); } catch (e) { /* ignore */ }
    /* batch 3: back on this tab (Skio refetches its reward state on focus): read Skio's cards again */
    window.addEventListener('focus', optinBack);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') optinBack(); });
    /* batch 3: a client-side visit to Rewards reads the codes again (never from an earlier visit) */
    try { if (window.MKPortal && typeof window.MKPortal.onRoute === 'function') window.MKPortal.onRoute(function (r, prev) { if (prev && (!r || r.path !== prev.path)) codesReset(); optinUserCheck(); schedule(); }); } catch (e) { /* ignore */ }
    window.addEventListener('storage', function () { optinUserCheck(); });   /* r9 review: a route change (Skio's logout / login) or a login in another tab: still this customer's sign-up? */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
